module.exports = __webpack_public_path__ + "img/favicon.682cbeb7.svg";